import { instance } from '@/api/v2/instance';

import type { GetCurrentWeekByRoundIdResponseDto } from './week.dto';

export async function getCurrentWeekByRoundId(roundId: string) {
  const { data } = await instance.get<GetCurrentWeekByRoundIdResponseDto>(
    `/v3/rounds/current-week/${roundId}`,
  );

  if (data.success === false) {
    throw new Error(data.errorMessage);
  }

  return data.data;
}
